var isMobile = jQuery.browser.mobile;

$(document).ready(function () {
  fnAnimateLinks();
  AOS.init();
  var currentUrl = window.location.pathname;
  fnHoverProducto();
  genSlideTitDet();
  //fnSlideHome();
  //wow();
});

var wow = function() {
  new WOW().init();
}

var fnAnimateLinks = function () {
  $("a").on('click', function (event) {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function () {
        window.location.hash = hash;
      });
    }
  });
}




var fnSlideHome = function () {
	  $.fn.preload = function () {
	    this.each(function () {
	      $('<img/>')[0].src = this;
	    });
	  }
	  var images = Array(
      "../../assets/img/bg-header-viguetas.jpg",
      "../../assets/img/bg-header-fabrica.jpg");
    
      
	  $([images[0], images[1]]).preload();

	  var timeSlide = 10000;
	  var currimg = 0;

	  // $("#text-home1").removeClass("d-flex").hide();
	  //$("#text-home2").removeClass("d-flex").hide();

	  function loadimg() {

	    $('header.header').animate({ opacity: 1 }, 500, function () {
	      $('header.header').animate({ opacity: 0.7 }, 800, function () {
	        currimg++;
	        if (currimg > images.length - 1) {
	          currimg = 0;
	        }
	        /*
	        if(currimg === 0){
	          $("#text-home1").show();
	          $("#text-home2").removeClass("d-flex").hide();
	        }else{
	          $("#text-home1").removeClass("d-flex").hide();
	          $("#text-home2").show();
	        }
	        */
	        var newimage = images[currimg];
	        $('header.header').css("background-image", "url(" + newimage + ")");
	        $('header.header').animate({ opacity: 1 }, 400, function () {
	          setTimeout(loadimg, timeSlide);
	        });
	      });
	    });

	  }
	  setTimeout(loadimg, timeSlide);
	}






var genSlideTitDet = function () {

  var $titleS = $('.title-slide');
  $titleS.flickity({
    rightToLeft: false,
    contain: true,
    pageDots: false
  });

  var $detS = $('.detalle-producto');
  $detS.flickity({
    rightToLeft: false,
    contain: true,
    asNavFor: '.title-slide',
    prevNextButtons: false,
    draggable: false,
    pageDots: false
  });

  $detS.on( 'select.flickity', function( event, index ) {
    var srcFirstImg = $(".producto-ladrillos .detalle-body-slide.is-selected").find("li:first-child img").attr("src"),
        sOff = "off",
        sOn = "on";
    if(srcFirstImg.includes(sOff)){
      srcFirstImg = srcFirstImg.replace("off", "img");
      console.log("SRC111-------", srcFirstImg);
      $(".producto-ladrillos .detalle-body-slide.is-selected").find("li:first-child img").attr("src", srcFirstImg.replace("-img", "-on"));
      $(".img-producto img").attr("src", srcFirstImg);
    }else if(srcFirstImg.includes(sOn)){
      srcFirstImg = srcFirstImg.replace("on", "img");
      $(".img-producto img").attr("src", srcFirstImg);
    }


    var dataQty = $(".producto-ladrillos .detalle-body-slide.is-selected").find("li:first-child img").attr("data-qty");
    var dataPeso = $(".producto-ladrillos .detalle-body-slide.is-selected").find("li:first-child img").attr("data-peso");
    var dataQtym = $(".producto-ladrillos .detalle-body-slide.is-selected").find("li:first-child img").attr("data-qtym");
    $(".list-comercializacion").find(".desc-qty").text(dataQty);
    $(".list-comercializacion").find(".desc-peso").text(dataPeso);
    $(".list-comercializacion").find(".desc-qtym").text(dataQtym);


    if(index === 0){
      $(".list-productos ul li").removeClass("active");
      $(".list-productos ul li:nth-child(2)").addClass("active");
    }else if(index === 1){
      $(".list-productos ul li").removeClass("active");
      $(".list-productos ul li:nth-child(3)").addClass("active");
    }else if(index === 2){
      $(".list-productos ul li").removeClass("active");
      $(".list-productos ul li:nth-child(4)").addClass("active");
    }
  });

  $('.list-productos ul li a').on('click', function() {
    var indx = parseInt($(this).parent('li').index()) - 1;
    $detS.flickity( 'select', indx );
    $titleS.flickity( 'select', indx );
  });
}


var fnHoverProducto = function(){
  $(".img-detalle-producto").on("mouseenter", function(){
    $('.img-detalle-producto').each(function (index, value){
      var srcImgOff = $(this).attr("src").replace("-on.png", "-off.png");
      $(this).attr("src", srcImgOff);
    });
    var srcImg = $(this).attr("src");
    srcImg = srcImg.replace("off", "on");
    $(this).attr("src", srcImg);
  });
  $(".img-detalle-producto").on("mouseleave", function(){
    var srcImgProducto = $(".img-producto img").attr("src").replace("-img.png", "");
    var srcImg = $(this).attr("src").replace("-on.png", "");
    $('.img-detalle-producto').each(function (index, value){
      var srcImgOff = $(this).attr("src").replace("-on.png", "-off.png");
      $(this).attr("src", srcImgOff);
    });
    if(srcImgProducto == srcImg){
      $(this).attr("src", srcImg + "-on.png");
    }else{
      $(this).attr("src", srcImg + "-off.png");
    }

  });
  $(".img-detalle-producto").on("click", function(e){
    e.preventDefault();
    var srcImg = $(this).attr("src");
    var dataQty = $(this).attr("data-qty");
    var dataPeso = $(this).attr("data-peso");
    var dataQtym = $(this).attr("data-qtym");
    $(".list-comercializacion").find(".desc-qty").text(dataQty);
    $(".list-comercializacion").find(".desc-peso").text(dataPeso);
    $(".list-comercializacion").find(".desc-qtym").text(dataQtym);
    $(this).attr("src", srcImg);
    srcImg = srcImg.replace("on", "img");
    $(".img-producto img").attr("src", srcImg);

  });
}

/*
$(".ico-home a").on("click", function(){
  var catBtn = $(this).attr("data-categoria");
  console.log("catBtn", catBtn);
  $(".header").removeClass("header-ladrillos header-viguetas");
  $(".header").addClass("header-" + catBtn);
});
*/


$(".link-mapa").on("click", function(){
  var goTo = $(this).attr("href");
  $(".mapa-contacto").addClass("d-none");
  $(goTo).removeClass("d-none");
});

$('#carouselHeader').carousel({
  pause: true,
  interval: 10000
});